async function request(path, data) {
  const res = await fetch(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  const json = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(json.message || `Request failed with status ${res.status}`);
  }

  return json;
}

export function registerAccount(data) {
  return request('/api/auth/register', data);
}

export function changePassword(data) {
  return request('/api/auth/change-password', data);
}
